import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { BrowserModule } from '@angular/platform-browser';
import { TranslateModule } from '@ngx-translate/core';
import { ComumModule } from '././../../shared/comum.module';
import { translateLoaderNBS } from '././../../shared/translate-loader/translateLoader';
import { UsuarioFabricaCadastroComponent } from './usuario-fabrica-cadastro/usuario-fabrica-cadastro.component';
import { UsuarioFabricaFiltroComponent } from './usuario-fabrica-filtro/usuario-fabrica-filtro.component';
import { UsuarioFabricaListaComponent } from './usuario-fabrica-lista/usuario-fabrica-lista.component';
import { UsuarioFabricaService } from './usuario-fabrica-service/usuario-fabrica.service';
import { UsuarioFabricaComponent } from './usuario-fabrica.component';
import { DialogModule } from 'primeng/dialog';
import { TooltipModule } from 'primeng/tooltip';
import { CrudBase } from './../../../../src/app/shared/crud/CrudBase';

@NgModule({
  imports: [
    HttpModule,
    FormsModule,
    CommonModule,
    BrowserModule,
    ReactiveFormsModule,
    ComumModule,
    TranslateModule.forRoot(translateLoaderNBS),
    DialogModule,
    TooltipModule
  ],
  exports: [
    UsuarioFabricaComponent
  ],
  declarations: [
    UsuarioFabricaComponent,
    UsuarioFabricaCadastroComponent,
    UsuarioFabricaListaComponent,
    UsuarioFabricaFiltroComponent
  ],
providers: [
  UsuarioFabricaService
]
})
export class UsuarioFabricaModule { }
